export default {
  SPLIT_REGEX: /[-_]/g
};